import { render } from "./SkeletonCards.vue?vue&type=template&id=71280b2e"
import script from "./SkeletonCards.vue?vue&type=script&lang=js"
export * from "./SkeletonCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__